import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const BreadCrumbRoot = styled.div<{ showBreadCrumb?: string }>`
  display: none;
  flex-direction: row;
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  color: #7b86a3;

  @media (min-width: ${(props) => props.showBreadCrumb}) {
    display: flex;
  }

  #bar {
    color: ${(props) => props.theme.colors.primaryDark2};
  }

  #link {
    color: ${(props) => props.theme.colors.secundary};

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .divider {
    margin: 0 4px;
  }
`;

export type Page = {
  name: string;
  route: string;
  method?: 'push' | 'replace';
  state?: unknown;
};

interface IBreadCrumb {
  previouPages: Page[];
  currentPage: string;
  showBreadCrumbOnMinWidth?: string;
  onNavigateBackTo?: (index: number) => void;
}

const BreadCrumb: React.FC<IBreadCrumb> = ({
  previouPages,
  currentPage,
  showBreadCrumbOnMinWidth,
  onNavigateBackTo,
}) => {
  const history = useHistory();

  const handlerGoBack = (index: number) => {
    if (onNavigateBackTo) {
      onNavigateBackTo(index);
    } else {
      history.go(-(previouPages.length - index));
    }
  };

  return (
    <BreadCrumbRoot showBreadCrumb={showBreadCrumbOnMinWidth}>
      {previouPages.map((page, index) => (
        <React.Fragment key={index}>
          <span id='link' onClick={() => handlerGoBack(index)}>
            {page.name}
          </span>
          <span className='divider'>/</span>
        </React.Fragment>
      ))}
      <span id='bar'>{currentPage}</span>
    </BreadCrumbRoot>
  );
};

export default BreadCrumb;
